import { render, staticRenderFns } from "./DigitalChannels.vue?vue&type=template&id=2f626d79&scoped=true"
import script from "./DigitalChannels.vue?vue&type=script&lang=js"
export * from "./DigitalChannels.vue?vue&type=script&lang=js"
import style0 from "./DigitalChannels.vue?vue&type=style&index=0&id=2f626d79&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f626d79",
  null
  
)

export default component.exports